import {
    Wifi as WifiIcon,
    Pool as PoolIcon,
    FitnessCenter as FitnessCenterIcon,
    LocalLaundryService as LaundryIcon,
    DirectionsCar as ParkingIcon,
    Kitchen as KitchenIcon,
    Tv as TvIcon,
    AcUnit as AcIcon,
    Elevator as ElevatorIcon,
    Lock as SecurityIcon,
    LocalCafe as CafeIcon,
    Restaurant as RestaurantIcon,
    Pets as PetsIcon,
    Replay as ReplayIcon,
    Hotel as HotelIcon,
    TableBar as TableBarIcon,
    Chair as ChairIcon,
    WindPower as FanIcon
} from '@mui/icons-material';

// import a fallback icon
import ExtensionIcon from '@mui/icons-material/Extension'; // generic puzzle piece icon

const iconMap = {
    wifi: <WifiIcon />,
    pool: <PoolIcon />,
    gym: <FitnessCenterIcon />,
    "fitness center": <FitnessCenterIcon />,
    laundry: <LaundryIcon />,
    "washing machine": <LaundryIcon />,
    parking: <ParkingIcon />,
    kitchen: <KitchenIcon />,
    tv: <TvIcon />,
    ac: <AcIcon />,
    "air conditioning": <AcIcon />,
    elevator: <ElevatorIcon />,
    security: <SecurityIcon />,
    lock: <SecurityIcon />,
    cafe: <CafeIcon />,
    food: <RestaurantIcon />,
    restaurant: <RestaurantIcon />,
    pets: <PetsIcon />,
    bed: <HotelIcon />,
    table: <TableBarIcon />,
    chair: <ChairIcon />,
    fan: <FanIcon />
};

// export const getIconForTheText = (text) => iconMap[text.toLowerCase().trim()] || <ReplayIcon />;
// iconMapping.js
export const getIconForTheText = (text) => iconMap[text.toLowerCase().trim()] || null;

export const getFallbackIcon = () => <ExtensionIcon />; 

